import { render, staticRenderFns } from "./uploadVideo.vue?vue&type=template&id=246e4d9a&scoped=true&"
import script from "./uploadVideo.vue?vue&type=script&lang=js&"
export * from "./uploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideo.vue?vue&type=style&index=0&id=246e4d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e4d9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246e4d9a')) {
      api.createRecord('246e4d9a', component.options)
    } else {
      api.reload('246e4d9a', component.options)
    }
    module.hot.accept("./uploadVideo.vue?vue&type=template&id=246e4d9a&scoped=true&", function () {
      api.rerender('246e4d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comps/uploadVideo.vue"
export default component.exports